// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctRotation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 5.93704C6.43995 7.12641 5.21315 9.20477 5.02441 11.4078L7.4015 10.0354C7.81132 9.0737 8.52501 8.232 9.5 7.66909C11.8915 6.28838 14.9494 7.10775 16.3301 9.49922L15.4641 9.99922L18.6962 11.5973L18.9282 7.99922L18.0622 8.49922C16.1292 5.15117 11.848 4.00404 8.5 5.93704ZM18.7081 13.9995C18.2151 15.6539 17.113 17.1301 15.5 18.0614C12.152 19.9944 7.87082 18.8473 5.93782 15.4992L5.0718 15.9992L5.30385 12.4011L8.5359 13.9992L7.66987 14.4992C9.05058 16.8907 12.1085 17.7101 14.5 16.3293C15.4626 15.7736 16.1706 14.946 16.5828 13.9995H18.7081Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H24V0H0ZM22 2H2V22H22V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctRotation is a generated icon component.
 */
let IconMedOctRotation = IconMedOctRotation_1 = class IconMedOctRotation extends IconBaseElement {
    render() {
        return html `${IconMedOctRotation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctRotation.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctRotation = IconMedOctRotation_1 = __decorate([
    customElement('zui-icon-med-oct-rotation')
], IconMedOctRotation);
export { IconMedOctRotation };
